// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".foo .bar[data-v-a070ce96]{display:block;background-color:red}", ""]);
// Exports
module.exports = exports;
